"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DialogFooter = void 0;
var tslib_1 = require("tslib");
var React = tslib_1.__importStar(require("react"));
var TypeStyle = tslib_1.__importStar(require("typestyle"));
var TabStyles_1 = require("../../styles/TabStyles");
var Declarative_1 = require("../../utils/Declarative");
var FooterStyleName = TypeStyle.style({
    height: 48,
    flexShrink: 0,
});
var FooterContentStyleName = TypeStyle.style({
    height: '100%',
});
exports.DialogFooter = function (props) {
    return React.createElement("div", { className: FooterStyleName, "data-tb-test-id": Declarative_1.makeTestId(props.testId, 'Footer'), style: { padding: "0 " + props.sidePadding + "px" } }, props.children && React.createElement("div", { className: FooterContentStyleName, children: props.children }));
};
exports.DialogFooter.displayName = 'DialogFooter';
exports.DialogFooter.defaultProps = { sidePadding: TabStyles_1.TabStyles.Spacing.LargeSpace };
//# sourceMappingURL=DialogFooter.js.map